import React, { PureComponent } from "react";

class ScrollBar extends PureComponent {
  render() {
    const { length, currentPage } = this.props;

    const height = 100 / length;

    function getTop(id) {
      return id;
    }

    let top;
    switch (getTop(currentPage.id)) {
      case "about":
        top = "0";
        break;
      case "1":
        top = height + "%";
        break;
      case "2":
        top = height * 2 + "%";
        break;
      case "3":
        top = height * 3 + "%";
        break;
      default:
        top = "0";
    }

    return (
      <div className="fixed h-100 flex items-center" style={{ right: "0" }}>
        <div
          className="dn db-l bg-white-30 mr5 h-50 relative"
          style={{ width: "4px" }}
        >
          <div
            className="bg-white absolute ease"
            style={{ width: "4px", height: height + "%", top }}
          />
        </div>
      </div>
    );
  }
}

export default ScrollBar;



// WEBPACK FOOTER //
// ./src/components/ScrollBar.js